import {ValidatorFn, AbstractControl} from "@angular/forms";
import { Injectable } from "@angular/core";

@Injectable()
export class FormulaireDematValidators {

  constructor(){}

  static fileExtensionValidator(extensions: Array<string>): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      let rightExtension = false;
      let i = 0;
      while (!rightExtension && i < extensions.length) {
        rightExtension = !control.value || !control.value.name || control.value.name.endsWith(extensions[i]);
        i++;
      }
      return rightExtension ? null : {'fileExtension': {value: control.value.name}};
    };
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/src/app/common/validators/formdemat.validator.ts